const load = ({ cookies }) => {
  cookies.set("accessToken", "", { path: "/", expires: /* @__PURE__ */ new Date() });
  return {
    page_title: "Logout"
  };
};
export {
  load
};
//# sourceMappingURL=_page.server.ts.js.map
